// Свёрнутый шаг показывает ключ маской: узнать своё подключение по последним символам можно,
// а светить секрет целиком на экране, который открывают при гостях, незачем.
export const maskApiKey = (apiKey: string): string => {
    const tail = apiKey.slice(-4);

    return tail.length === 4 ? `•••• •••• •••• ${tail}` : "•••• •••• ••••";
};
